import { render } from "./SalesLeadForm.vue?vue&type=template&id=d406bf56&scoped=true&ts=true"
import script from "./SalesLeadForm.vue?vue&type=script&lang=ts"
export * from "./SalesLeadForm.vue?vue&type=script&lang=ts"

import "./SalesLeadForm.vue?vue&type=style&index=0&id=d406bf56&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d406bf56"]])

export default __exports__